<script>
import Layout from "../../layouts/auth";
import appConfig from "@/app.config";

export default {
  page: {
    title: "SignupSelector",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {};
  },
};
</script>

<template>
  <Layout>
    <section class="signup-selector">
      <div class="signup">
        <div class="header">
          <div class="logo">
            <img
              src="@/assets/images/logo-lg.svg"
              class="unselectable mx-auto"
              alt
              width="170px"
              height="32px"
            />
          </div>
          <span class="subtitle">Register</span>
        </div>
        <div class="content">
          <div class="item" @click="$router.push('/register-passport')">
            <div class="info">
              <div class="item-icon-wrapper passport-icon">
                <img
                  src="@/assets/images/passport-register.svg"
                  class="item-icon"
                  alt
                />
              </div>
              <div>
                <p class="item-title">VisiPoint Passport</p>
                <p class="item-subtitle">
                  Get a QuickPass QR code for speedy check-in at any VisiPoint
                  location
                </p>
              </div>
            </div>
            <div class="icon-wrapper">
              <i class="mdi mdi-chevron-right redirect-icon"></i>
            </div>
          </div>
          <hr class="hr-line" />
          <div class="item dashboard-info" @click="$router.push('/register')">
            <div class="info">
              <div class="item-icon-wrapper dashboard-icon">
                <img
                  src="@/assets/images/dashboard-register.svg"
                  class="item-icon"
                  alt
                />
              </div>
              <div>
                <p class="item-title">Company Dashboard</p>
                <p class="item-subtitle">
                  Create your company dashboard and get VisiPoint Passport with
                  a QuickPass QR code
                </p>
              </div>
            </div>
            <div class="icon-wrapper">
              <i class="mdi mdi-chevron-right redirect-icon"></i>
            </div>
          </div>
        </div>
        <div class="login-btn-section">
          <p class="margin-subtitle">Already have an account?</p>
          <div class="login-btn">
            <router-link to="/login" >LOGIN</router-link>
          </div>
        </div>
      </div>
    </section>
  </Layout>
</template>


<style lang="scss" scoped>
@media (max-width: 992px){
  .logo{
    width:116px!important;
    height: 22px!important;
   img{
  width:116px!important;
  height: 22px!important;
}
}
}
.signup-selector {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  .signup {
    width: 485px;
    .header {
      text-align: center;
      width: 485px;
      background: #ffffff;
      border-radius: 26px;
      padding-top: 26px;
      padding-bottom: 20px;
      margin-bottom: 20px;
      .logo {
        margin-bottom: 6px;
        margin-right: auto;
        margin-left: auto;
      }
      .subtitle {
        font-weight: 500;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.28);
      }
    }
    .content {
      background-color: #fff;
      border-radius: 26px;
      padding: 35px 40px;
      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 21px;
        cursor: pointer;
        .info {
          display: flex;
          margin-right: 33px;
          .item-icon-wrapper {
            margin-right: 30px;
            .item-icon {
              width: 100%;
            }
          }
          .passport-icon {
            width: 13%;
          }
          .dashboard-icon {
            width: 15%;
          }
          .item-title {
            font-weight: bold;
            font-size: 18px;
            text-transform: uppercase;
            color: #000000;
            margin-bottom: 17px;
          }
          .item-subtitle {
            font-weight: 500;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.28);
            margin-bottom: 0;
          }
        }
        .redirect-icon {
          color: #000;
          font-size: 33px;
          cursor: pointer;
          transition: 0.3s;

          &:hover {
            color: #103f5e;
          }
        }
      }
      .hr-line {
        margin-bottom: 33px;
      }
      .dashboard-info {
        margin-bottom: 0 !important;
      }
    }
    .margin-subtitle {
      @extend .subtitle;
      margin-bottom: 22px;
    }
    .login-btn-section {
      @extend .header;
      padding-bottom: 22px !important;
      .login-btn {
        font-size: 16px;
        font-weight: 700;
        color: #103f5e;
      }
    }
    .login-btn-section{
      margin-top: 20px!important;
      margin-bottom: 20px!important;
    }
  }
}
</style>
